import Polyglot from 'node-polyglot';
import cs from './cs';
import en from './en';
import {DEFAULT_LANGUAGE} from '../constants';

let _ = {};
let instance = {};

function setLang(lang = DEFAULT_LANGUAGE) {
  let phrases = {};

  switch (lang) {
    case 'cs':
      phrases = cs;
      break;
    case 'en':
      phrases = en;
      break;
    default:
      phrases = cs;
  }

  // TODO: remove - currently CMP supports only "cs"
  phrases = cs;

  instance = new Polyglot({phrases});
  _ = instance.t.bind(instance);
}

export {_, setLang};
export default instance;
